const u = navigator.userAgent;
// var appid="wx654440b026861de2";//姜子牙经代云服
// var appid="wxe4ea1755d6ab3c82";//姜子牙出单
// var appid="wx1a86bb7e7f5e7797";//保险服务助手
// var appid="wx50a095f10fed08ba";//探保课堂plus  测试用公众号

// var appid="wx84c7f44ac41384e8";//小桐保险测评  测试用公众号
// var appid="wx8783ef3a6ad74a7a";//凤栖云平台
// var appid="wxd3ac56e0c6b999a0";//蜡烛云
// var appid="wx27ea6e5f962e22c5";//ok保合伙人
// var appid="wx21a94aa566cb3351";//蜡烛云演示
// var appid="wx134ae829d580b6a6";//微投管家
const appid = ["wx84c7f44ac41384e8", "wx134ae829d580b6a6", "wx84c7f44ac41384e8", "wx134ae829d580b6a6"]
const commponentAppid = ["wx7fea32115164fd51", "wxe2cd7fe12329b0ae", "wx7fea32115164fd51", "wxe2cd7fe12329b0ae"]//开放者平台appid
const common = {
  env: API_CONFIG.ENV, //环境 0测试 1正式 2本地 3演示
  appId: appid[API_CONFIG.ENV],//分享客户用
  root: API_CONFIG.ENV==2?'https://h5-test.lazhuyun.cn':location.origin,
  ajaxRoot: API_CONFIG.AJAX_ROOT,
  productBase: API_CONFIG.PRODUCT_BASE,
  commponentAppid: commponentAppid[API_CONFIG.ENV],//登录授权
  isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
  isApp: u.indexOf('com.wts.fqtd') > -1,
  appVer: "1.7.0",
  ver: API_CONFIG.VER
}
export default common;
